/* eslint-disable jsx-a11y/anchor-has-content,react/prefer-stateless-function,no-useless-constructor */
import React, { Component } from 'react';
import { NavLink, withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import * as formatter from 'mt-react-common/utils/formatter';
import _ from 'lodash';
import { printHtml } from 'utils';

import TaskExecLogMaterialItem from './items/TaskExecLogMaterialItem';
import MoreUserReports from './MoreUserReports';

class TaskExecLogItem extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    if (!this.props.execLogItem) {
      return <p>Нет лога</p>;
    }
    // eslint-disable-next-line no-unused-vars
    let logTitleIconClass = null;
    let logTypeContextClass = null;
    switch (this.props.execLogItem.eventType) {
      case 1: {
        logTitleIconClass = 'fa fa-play-circle';
        logTypeContextClass = 'blockquote_success';
        break;
      }
      case 2: {
        logTitleIconClass = 'fa fa-file-text';
        logTypeContextClass = 'blockquote_primary';
        break;
      }
      case 3: {
        logTitleIconClass = 'fa fa-times-circle';
        logTypeContextClass = 'blockquote_danger';
        break;
      }
      case 4: {
        logTitleIconClass = 'fa fa-undo';
        logTypeContextClass = 'blockquote_danger';
        break;
      }
      case 5: {
        logTitleIconClass = 'fa fa-comment';
        logTypeContextClass = 'blockquote_primary';
        break;
      }
      case 6: {
        logTitleIconClass = 'fa fa-check-circle';
        logTypeContextClass = 'blockquote_success';
        break;
      }
      case 7: {
        logTitleIconClass = 'fa fa-check-circle';
        logTypeContextClass = 'blockquote_success';
        break;
      }
      case 8: {
        logTitleIconClass = 'fa fa-play-circle';
        logTypeContextClass = 'blockquote_success';
        break;
      }
      case 9: {
        logTitleIconClass = 'fa fa-times-circle';
        logTypeContextClass = 'blockquote_danger';
        break;
      }
      case 10: {
        logTitleIconClass = 'fa fa-gavel';
        logTypeContextClass = 'blockquote_warning';
        break;
      }
      case 11: {
        logTitleIconClass = 'fa fa-gavel';
        logTypeContextClass = 'blockquote_warning';
        break;
      }
      case 12: {
        logTitleIconClass = 'fa fa-gavel';
        logTypeContextClass = 'blockquote_warning';
        break;
      }
      case 13: {
        logTitleIconClass = 'fa fa-times-circle';
        logTypeContextClass = 'blockquote_danger';
        break;
      }
      default:
        break;
    }
    return (
      <div className="media media_comment media_comment_try">
        <div className="media-left">
          <NavLink
            to={`/users/profile/${this.props.execLogItem.userId}`}
            title={this.props.execLogItem.execUserName}
          >
            <img
              alt=""
              className="media-object avatar avatar-sm"
              src={this.props.execLogItem.execUserAvatar}
            />
          </NavLink>
        </div>
        <div className="media-body media-middle">
          <div className="media-info">
            <NavLink
              to={`/users/profile/${this.props.execLogItem.userId}`}
              className="media-info-name"
            >
              {this.props.execLogItem.execUserName} (
              {this.props.execLogItem.execUserRole})
            </NavLink>
            <span className="media-info-desc">
              {' '}
              {formatter.dateFormat5(this.props.execLogItem.createdAt)}
            </span>
          </div>
          <div className={`blockquote ${logTypeContextClass}`}>
            <div className="blockquote-title">
              <i className={`${logTitleIconClass}`} />{' '}
              {this.props.execLogItem.eventTypeDesc}
            </div>
            {this.props.execLogItem.ip ? (
              <div className="text-muted">
                <i className="fa fa-map-pin" /> IP {this.props.execLogItem.ip}
              </div>
            ) : null}
            {!_.isEmpty(this.props.execLogItem.data) ||
            !_.isEmpty(this.props.execLogItem.materials) ? (
              <div className="panel panel-default m-t-5 m-b-0">
                <div
                  className="panel-body"
                  style={{
                    whiteSpace: 'pre-line',
                    overflowWrap: 'break-word',
                    wordBreak: 'break-word'
                  }}
                >
                  {!_.isEmpty(this.props.execLogItem.data) &&
                  this.props.execLogItem.data.text ? (
                    <p>{printHtml(this.props.execLogItem.data.text)}</p>
                  ) : null}
                  {!_.isEmpty(this.props.execLogItem.materials) ? (
                    <figure className="offset_bottom_xxs offset_right_xxs">
                      {this.props.execLogItem.materials.map(item => (
                        <TaskExecLogMaterialItem
                          key={`taskExecLogMaterialItem-${item.id}`}
                          materialItem={item}
                        />
                      ))}
                    </figure>
                  ) : null}
                </div>
              </div>
            ) : null}
            <MoreUserReports
              execLogItem={this.props.execLogItem}
              userRepeatsAmount={this.props.userRepeatsAmount}
            />
          </div>
        </div>
      </div>
    );
  }
}

TaskExecLogItem.propTypes = {
  execLogItem: PropTypes.shape({
    ip: PropTypes.string.isRequired,
    userId: PropTypes.number.isRequired,
    eventType: PropTypes.number.isRequired,
    eventTypeDesc: PropTypes.string.isRequired,
    execUserAvatar: PropTypes.string.isRequired,
    execUserName: PropTypes.string.isRequired,
    execUserRole: PropTypes.string.isRequired,
    createdAt: PropTypes.string.isRequired,
    materials: PropTypes.arrayOf(PropTypes.shape).isRequired,
    data: PropTypes.shape.isRequired
  }).isRequired,
  userRepeatsAmount: PropTypes.number
};

TaskExecLogItem.defaultProps = {
  userRepeatsAmount: null
};

export default withRouter(TaskExecLogItem);



// WEBPACK FOOTER //
// ./src/components/Tasks/TasksExecsLists/_items/TaskExecLogItem/TaskExecLogItem.js